/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {useQueryResponseLoading, useQueryResponsePagination} from '../../core/QueryResponseProvider'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {PaginationState} from '../../../../../../../../_metronic/helpers'
import {useMemo} from 'react'

const mappedLabel = (label: string): string => {
  if (label === '« Previous') return 'Previous'
  if (label === 'Next »') return 'Next'
  return label
}

const ListPagination = () => {
  const pagination = useQueryResponsePagination()
  const isLoading = useQueryResponseLoading()
  const {updateState} = useQueryRequest()

  const currentPage = pagination.page || 1
  const itemsPerPage = pagination.items_per_page || 10
  const totalItems = pagination.total || 0
  
  const showingFrom = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1
  const showingTo = Math.min(currentPage * itemsPerPage, totalItems)

  const updatePage = (page: number | undefined | null) => {
    if (!page || isLoading || pagination.page === page) {
      return
    }
    updateState({page, items_per_page: itemsPerPage})
  }

  const PAGINATION_PAGES_COUNT = 5
  const sliceLinks = (pagination?: PaginationState) => {
    if (!pagination?.links?.length) return []

    let scopedLinks = [...pagination.links]
    let pageLinks: Array<{
      label: string
      active: boolean
      url: string | null
      page: number | null
    }> = []
    
    let previousLink = scopedLinks.shift()!
    let nextLink = scopedLinks.pop()!

    const halfOfPagesCount = Math.floor(PAGINATION_PAGES_COUNT / 2)
    pageLinks.push(previousLink)

    if (
      pagination.page <= Math.round(PAGINATION_PAGES_COUNT / 2) ||
      scopedLinks.length <= PAGINATION_PAGES_COUNT
    ) {
      pageLinks = [...pageLinks, ...scopedLinks.slice(0, PAGINATION_PAGES_COUNT)]
    } else if (
      pagination.page > scopedLinks.length - halfOfPagesCount &&
      scopedLinks.length > PAGINATION_PAGES_COUNT
    ) {
      pageLinks = [
        ...pageLinks,
        ...scopedLinks.slice(scopedLinks.length - PAGINATION_PAGES_COUNT, scopedLinks.length),
      ]
    } else {
      pageLinks = [
        ...pageLinks,
        ...scopedLinks.slice(
          pagination.page - 1 - halfOfPagesCount,
          pagination.page + halfOfPagesCount
        ),
      ]
    }

    pageLinks.push(nextLink)
    return pageLinks
  }

  const paginationLinks = useMemo(() => sliceLinks(pagination), [pagination])

  return (
    <div className='d-flex align-items-center justify-content-between py-10 px-8'>
      <div className='fs-7 fw-bold text-gray-700'>
        Showing <span className="text-dark">{showingFrom}</span> to <span className="text-dark">{showingTo}</span> of <span className="text-dark">{totalItems}</span> entries
      </div>

      <div id='sc_table_users_paginate'>
        <ul className='pagination'>
          <li className={clsx('page-item', { disabled: isLoading || currentPage === 1 })}>
            <a onClick={() => updatePage(1)} style={{cursor: 'pointer'}} className='page-link'>
              First
            </a>
          </li>

          {paginationLinks?.map((link) => {
            const label = mappedLabel(link.label)
            return (
              <li
                key={link.label}
                className={clsx('page-item', {
                  active: pagination.page === link.page,
                  disabled: isLoading || (!link.page && !link.active),
                  previous: label === 'Previous',
                  next: label === 'Next',
                })}
              >
                <a
                  className={clsx('page-link', {
                    'page-text': label === 'Previous' || label === 'Next',
                    'me-1': label === 'Previous',
                  })}
                  onClick={() => updatePage(link.page)}
                  style={{cursor: 'pointer'}}
                >
                  {label}
                </a>
              </li>
            )
          })}

          <li
            className={clsx('page-item', {
              disabled: isLoading || currentPage === (pagination.links?.length! - 2),
            })}
          >
            <a
              onClick={() => updatePage(pagination.links?.length! - 2)}
              style={{cursor: 'pointer'}}
              className='page-link'
            >
              Last
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}

export {ListPagination}